.imagePagination {
  width: 100%;
}

.buttonWrapper {
  display: none;
}

.buttonWrapper svg {
  flex: none;
}

.leftButtonWrapper {
  top: calc(50% - 24px); /* 24px is half of the button height */
  right: 10px;
}

.rightButtonWrapper {
  top: calc(50% - 24px);
  left: 10px;
}

.paginationText {
  line-height: 16px;
  font-size: 13px;
}

.paginationTextWrapper {
  position: absolute;
  background: rgb(0 0 0 / 50%);
  border-radius: 16px;
  padding: 3px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.paginationTextWrapperPosition {
  top: 16px;
  right: 16px;
  bottom: auto;
}

.paginationTextWrapperPosition-top {
  /* stylelint-disable-next-line declaration-no-important */
  bottom: auto !important;
  /* stylelint-disable-next-line declaration-no-important */
  top: 16px !important;
}

.paginationTextWrapperPosition-bottom {
  /* stylelint-disable-next-line declaration-no-important */
  bottom: 16px !important;
  /* stylelint-disable-next-line declaration-no-important */
  top: auto !important;
}

@media all and (--reefer-media-tablet-min) {
  .buttonWrapper {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: rgb(0 0 0 / 50%);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    padding: 12px;
  }

  .paginationTextWrapperPosition {
    bottom: 16px;
    right: 16px;
    top: auto;
  }

  .paginationText {
    line-height: unset;
    font-size: unset;
  }
}
